import { FC, lazy } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import { ErrorCode } from '@/lib/apollo/types/gen/graphql';
import BasicGuard from '@/routes/middlewares/BasicGuard';
import NotMemberGuard from '@/routes/middlewares/NotMemberGuard';
import ConfirmRoute from '@/routes/SignUp/middlewares/confirmRoute';
import IndexRoute from '@/routes/SignUp/middlewares/indexRoute';
import RegistrationRoute from '@/routes/SignUp/middlewares/registrationRoute';
import VerifyRoute from '@/routes/SignUp/middlewares/verifyRoute';

const IndexPage = lazy(() => import('@/pages/SignUp'));
const RegistrationPage = lazy(() => import('@/pages/SignUp/registration'));
const ConfirmPage = lazy(() => import('@/pages/SignUp/confirm'));
const CompletePage = lazy(() => import('@/pages/SignUp/complete'));
const SmsCompletePage = lazy(() => import('@/pages/SignUp/smscomplete'));
const IssuePage = lazy(() => import('@/pages/Mypage/OneTimePass/Issue'));

const ErrorPage = lazy(() => import('@/pages/Error'));

const SignUpRoutes: FC = () => {
  return (
    <Switch>
      <Route
        index
        element={
          <NotMemberGuard>
            <IndexRoute Component={IndexPage} />
          </NotMemberGuard>
        }
      />
      <Route
        path="registration"
        element={
          <NotMemberGuard>
            <RegistrationRoute Component={RegistrationPage} />
          </NotMemberGuard>
        }
      />
      <Route
        path="confirm"
        element={
          <NotMemberGuard>
            <ConfirmRoute Component={ConfirmPage} />
          </NotMemberGuard>
        }
      />
      <Route
        path="verify"
        element={
          <BasicGuard>
            <VerifyRoute Component={IssuePage} />
          </BasicGuard>
        }
      />
      <Route
        path="complete"
        element={
          <BasicGuard>
            <CompletePage />
          </BasicGuard>
        }
      />
      <Route
        path="smscomplete"
        element={
          <BasicGuard>
            <SmsCompletePage />
          </BasicGuard>
        }
      />

      <Route
        path="*"
        element={<ErrorPage forceErrorCode={ErrorCode.NotFound} />}
      />
    </Switch>
  );
};

export default SignUpRoutes;
